/**
 * 设置本地时间和服务器时间的差值
 * @param respData
 */
export function setServerTimeDiff(respData) {
    if (respData === null || respData === void 0 ? void 0 : respData.serverTime) {
        // 服务器返回的serverTime以秒为单位
        var isValidTime = new Date(respData.serverTime * 1000).toString() !== new Date(1).toString();
        if (isValidTime) {
            var win = window;
            win.__serverTimeDiff__ = respData.serverTime - parseInt((Date.now() / 1000).toString(), 10);
        }
    }
}
